import script from "./DetailRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequest.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequest.vue?vue&type=style&index=0&id=04534b75&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04534b75"]])

export default __exports__